import React, { useState, useEffect } from "react";
import "./MobileAboutBrands.css";
import { useSelector } from "react-redux";
import { selectProductDetails } from "../../features/productDesc/productDescSlice";
import Funn from "../../components/ProductDescription/BrandsDetails/Funn";
import Cratoni from "../../components/ProductDescription/BrandsDetails/Cratoni";
import Moon from "../../components/ProductDescription/BrandsDetails/Moon";
import Granite from "../../components/ProductDescription/BrandsDetails/Granite";
import Proride from "../../components/ProductDescription/BrandsDetails/Proride";
import BikePro from "../../components/ProductDescription/BrandsDetails/BikePro";
import Dass from "../../components/ProductDescription/BrandsDetails/Dass";
import SovereignSaddles from "../../components/ProductDescription/BrandsDetails/SovereignSaddles";
import MasterChains from "../../components/ProductDescription/BrandsDetails/MasterChains";
import Katour from "../../components/ProductDescription/BrandsDetails/Katour";
import GarrariBrand from "../../components/ProductDescription/BrandsDetails/GarrariBrand";
import Hartex from "../../components/ProductDescription/BrandsDetails/Hartex";
import Radkaat from "../../components/ProductDescription/BrandsDetails/Radkaat";
import Shimano from "../../components/ProductDescription/BrandsDetails/Shimano";

function MobileAboutBrands() {
  const productSelect = useSelector(selectProductDetails);
  const [componentToRender, setComponentToRender] = useState(null);
  useEffect(() => {
    if (
      productSelect &&
      productSelect.products &&
      productSelect.products.length > 0
    ) {
      const manufacturer = productSelect.products[0].Manufacturer;

      switch (manufacturer?.toUpperCase()) {
        case "FUNN":
          setComponentToRender(<Funn />);
          break;
        case "CRATONI":
          setComponentToRender(<Cratoni />);
          break;
        case "SHIMANO":
          setComponentToRender(<Shimano />);
          break;
        case "GRANITE":
          setComponentToRender(<Granite />);
          break;
        case "MOON SPORTS":
          setComponentToRender(<Moon />);
          break;
        case "PRORIDE":
          setComponentToRender(<Proride />);
          break;
        case "BIKEPRO":
          setComponentToRender(<BikePro />);
          break;
        case "DASS":
          setComponentToRender(<Dass />);
          break;
        case "SOVEREIGN":
          setComponentToRender(<SovereignSaddles />);
          break;
        case "MASTER":
          setComponentToRender(<MasterChains />);
          break;
        case "KATOUR":
          setComponentToRender(<Katour />);
          break;
        case "GARRARI BIKES":
          setComponentToRender(<GarrariBrand />);
          break;
        case "HARTEX":
          setComponentToRender(<Hartex />);
          break;
        case "RADKAAT":
          setComponentToRender(<Radkaat />);
          break;
        default:
          setComponentToRender(null);
      }
    }
  }, [productSelect]);
  return (
    <div className="mobile-about_containers">
      {/* <h3 className="about_heading">About Brands</h3> */}
      {componentToRender}
    </div>
  );
}

export default MobileAboutBrands;
